var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { registerRestApi } from './RestApiService.js';
let QboApiElement = class QboApiElement extends LitElement {
    constructor() {
        super(...arguments);
        this.name = null;
        this.apiEndpoint = null;
    }
    connectedCallback() {
        super.connectedCallback();
        const headers = {};
        if (this.name == null)
            console.error('qbo-api name is required.');
        if (this.apiEndpoint == null)
            console.error('qbo-api apiEndpoint is required.');
        const headerElements = this.querySelectorAll('header');
        headerElements.forEach(header => {
            const name = header.getAttribute('name');
            const value = header.textContent;
            if (name && value) {
                headers[name] = value;
            }
        });
        // Adjust for correct header naming convention, if necessary
        if (headers['ContentType']) {
            headers['Content-Type'] = headers['ContentType'];
            delete headers['ContentType'];
        }
        // container.registerInstance<IApiService>(this.name!, new RestApiService(this.apiEndpoint!, headers, this.method));
        // Call the registerRestApi function with the extracted configuration
        if (!this.apiEndpoint?.startsWith("http"))
            this.apiEndpoint = new URL(this.apiEndpoint ?? '', document.location.origin).href;
        registerRestApi(this.name, this.apiEndpoint, headers, this.method);
    }
    render() {
        // Render nothing, as this component is for configuration purposes only
        return html ``;
    }
};
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboApiElement.prototype, "name", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], QboApiElement.prototype, "apiEndpoint", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboApiElement.prototype, "method", void 0);
QboApiElement = __decorate([
    customElement('qbo-api')
], QboApiElement);
export { QboApiElement };
